import { Mapper } from '../../../common/ddd/mapper.base';
import { formatDeviation } from '../../../common/utils/format-deviation.util';
import { ChallengeSentimentAggregateRoot } from '../../../core/domain/aggregates/challenge-insights/challenge-sentiment.aggregate-root';
import { GetAccountMetricsInsightsAveragesResponseDto } from '../../../interface/dtos/challenge-insights/get-account-metrics-insights-averages.response.dto';

export class ChallengeSentimentAggregateRootMapper
  implements
    Omit<
      Mapper<
        ChallengeSentimentAggregateRoot,
        GetAccountMetricsInsightsAveragesResponseDto
      >,
      'toDomain'
    >
{
  toResponse(
    entity: ChallengeSentimentAggregateRoot
  ): GetAccountMetricsInsightsAveragesResponseDto {
    return ChallengeSentimentAggregateRootMapper.toResponse(entity);
  }
  static toResponse(
    entity: ChallengeSentimentAggregateRoot
  ): GetAccountMetricsInsightsAveragesResponseDto {
    return {
      deviation: `${formatDeviation(Math.round(entity.deviationPercentage))}`,
      beforeValue: Number(entity.beforeValue.toFixed(1)),
      afterValue: Number(entity.value.toFixed(1)),
      beforeFormattedValue: String(entity.beforeValue.toFixed(1)),
      afterFormattedValue: String(entity.value.toFixed(1)),
      averageDeviation: `${formatDeviation(
        Math.round(entity.averageDeviationPercentage)
      )}`,
      beforeAverage: Number(entity.beforeAverage.toFixed(1)),
      afterAverage: Number(entity.average.toFixed(1)),
      beforeFormattedAverage: String(entity.beforeAverage.toFixed(1)),
      afterFormattedAverage: String(entity.average.toFixed(1)),
    };
  }
}
